import { AllAccordions } from "./accordion";

function searchAndHighlight(e) {
    let input, filter, container, cards, title, titleValue, content, paragraphs, paragraph, paragraphValue;

    container = document.querySelector('.accordions');
    cards = container.querySelectorAll('.accordion__card');
    input = e.target;
    filter = input.value.toUpperCase();

    for (var i = 0; i < cards.length; i++) {
        cards[i].classList.add('transition-all', 'duration-300', 'ease-in-out');

        title = cards[i].querySelector('.accordion__title h3');
        titleValue = title.textContent || title.innerText;

        content = cards[i].querySelector('.card__content');
        paragraphs = content.querySelectorAll('p');

        const titleMatches = titleValue.match(new RegExp(filter, 'gi'));
        let hasContentMatch = false;

        for (var p = 0; p < paragraphs.length; p++) {
            paragraph = paragraphs[p];
            paragraphValue = paragraph.textContent || paragraph.innerText;

            const paragraphMatches = paragraphValue.match(new RegExp(filter, 'gi'));
            paragraph.innerHTML = paragraphMatches ?
                paragraphValue.replace(new RegExp(filter, 'gi'), '<span class="bg-yellow-300">$&</span>') :
                paragraphValue;

            if (paragraphMatches) {
                hasContentMatch = true;
            }
        }

        const hasTitleMatch = titleMatches !== null;
        const hasMatch = hasTitleMatch || hasContentMatch;
        const targetAccordionInstance = AllAccordions.get(cards[i]);

        // Highlight the title
        title.innerHTML = hasTitleMatch ? titleValue.replace(new RegExp(filter, 'gi'), '<span class="bg-yellow-300">$&</span>') : titleValue;

        if (hasMatch) {
            // Make sure the card is visible
            cards[i].classList.remove("slide-out");

            if (targetAccordionInstance) {
                if (!targetAccordionInstance.isOpen) {
                    targetAccordionInstance.open();
                }
            }
        } else {
            if (targetAccordionInstance) {
                targetAccordionInstance.close();
            }

            // Hide the card
            cards[i].classList.add("slide-out");
        }
    }
}

// Init quick search
const targets = document.querySelectorAll("[data-quick-search]");
targets.forEach((targetEl) => {
    targetEl.addEventListener("keyup", searchAndHighlight);
});
